'use strict';

var React = require("react");

((require("../styles/preview-illustration.css")));

function PreviewIllustration(Props) {
  return React.createElement("div", {
              className: "preview-illustration-container"
            }, React.createElement("div", {
                  className: "preview-illustration"
                }));
}

var make = PreviewIllustration;

exports.make = make;
/*  Not a pure module */
